import { render, staticRenderFns } from "./ContactAdd.vue?vue&type=template&id=b692f97e&scoped=true&"
import script from "./ContactAdd.vue?vue&type=script&lang=js&"
export * from "./ContactAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b692f97e",
  null
  
)

export default component.exports